import {Bounds} from '../types'

export const getDisplayBounds = (width: number, height: number): Bounds => ({
  topLeft: {x: 0, y: 0},
  bottomRight: {x: width, y: height}
})
